import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import LandingPage from "@/pages/LandingPage";
import CekiciPage from "@/pages/CekiciPage";
import LegalPage from "@/pages/LegalPage";
import NotFound from "@/pages/NotFound";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/cekici" element={<CekiciPage />} />
        <Route path="/kvkk" element={<LegalPage key="kvkk" />} />
        <Route path="/gizlilik-politikasi" element={<LegalPage key="gizlilik" />} />
        <Route path="/cerez-politikasi" element={<LegalPage key="cerez" />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
